<textarea readonly style="width:calc(100% - 0.625rem)" rows="15">
{{operationsDisplay}}</textarea>
